import React from 'react'

export default props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
    <path
      d="M91.2 44.07c0-16.43-18.62-29.7-41.6-29.7S8 27.68 8 44.07c0 9.43 6.13 17.83 15.7 23.27-2.18 7.75-5.53 10.54-8.45 13.83-.7.84-1.5 1.53-1.26 2.7h0a2.15 2.15 0 0 0 2.23 1.77 40.4 40.4 0 0 0 5.3-1 51.06 51.06 0 0 0 21.33-11.22 64.78 64.78 0 0 0 6.74.37c23 0 41.6-13.28 41.6-29.72"
      fill="#545454"
    />
    <path
      d="M39.8 44.4c0 7.16-5.08 10.44-10.3 10.44-5.72 0-10.12-3.76-10.12-10.08S23.53 34.4 29.8 34.4c6 0 10 4.12 10 10zm-14.15.2c0 3.36 1.4 5.88 4 5.88 2.35 0 3.87-2.36 3.87-5.88 0-2.92-1.1-5.88-3.87-5.88-2.92 0-4 3-4 5.88zM62 48.12l.16 6.28h-5.28l-.28-2.76h-.1a7 7 0 0 1-6.12 3.2c-4 0-6.88-2.48-6.88-8.52V34.84h6.12v10.52c0 2.84.92 4.56 3 4.56a3.25 3.25 0 0 0 3-2.12 3.4 3.4 0 0 0 .2-1.32V34.84H62zm11.7-18.88v5.6H78v4.48h-4.3v7.08c0 2.36.56 3.44 2.4 3.44a10 10 0 0 0 1.8-.16v4.6a11.82 11.82 0 0 1-4 .52 6.32 6.32 0 0 1-4.56-1.68c-1.12-1.16-1.68-3-1.68-5.8v-8h-2.6v-4.48h2.6V30.6z"
      fill="#fff"
    />
  </svg>
)
